const SELECTORS = {
    image: '.js-product-card-img',
    reflection: '.js-product-card-reflection'
}

class ProductCard extends HTMLElement {
    constructor() {
        super()

        this.elements = {
            image: this.querySelector(SELECTORS.image),
            reflection: this.querySelector(SELECTORS.reflection)
        }
    }

    connectedCallback() {
        const image = this.elements.image
        if (image) {
            if (image.complete) {
                this.setReflection(image.currentSrc)
            } else {
                const handleImageLoad = () => {
                    this.setReflection(image.currentSrc)
                    image.removeEventListener('load', handleImageLoad)
                }
                image.addEventListener('load', handleImageLoad)
            }
        }
    }

    setReflection(imageSrc) {
        const reflection = this.elements.reflection
        if (reflection) {
            reflection.style.backgroundImage = `url(${imageSrc})`
        }
    }
}

customElements.define('product-card', ProductCard)
